/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/21/20
 * Time: 6:11 PM
 */
export const YES_RESULT = "YES";
export const NO_RESULT = "NO";

export const healthConstants = [
  {
    covid_question_id: 1,
    english: 'Please indicate if you have travelled overseas and returned to Sri Lanka over the last 21 days',
    sinhala: 'පසුගිය දින 21 තුළ ඔබ විදෙස් ගත වී ශ්‍රී ලංකාවට පැමිණ තිබේදැයි කරුණාකර සඳහන් කරන්න',
    tamil: 'கடந்த 21 நாட்களில் நீங்கள் வெளிநாடுகளுக்குச் சென்று இலங்கைக்குத் திரும்பியிருக்கிறீர்களா?',
    chinese: '请指出您是否在过去21天内曾出国旅行并返回斯里兰卡',
    response: false,
    result: "",
  },
  {
    covid_question_id: 2,
    english: 'Have you had direct contact with confirmed / suspected / symptom / under quarantine  cases of COVID-19 during the past 21 days?',
    sinhala: 'පසුගිය දින 21 තුළ COVID-19 හි නිරෝධායන පනත යටතේ තහවුරු කරන ලද / සැක කරන ලද / රෝග ලක්‍ෂණ සමඟ ඔබ සෘජුව සම්බන්ධ වී තිබේද?',
    tamil: 'கடந்த 21 நாட்களில் COVID-19 தொற்றினால் தனிமைப்படுத்தப்பட்ட / உறுதிப்படுத்தப்பட்ட /  சந்தேகிக்கப்பட்ட / அறிகுறி இருந்தவர்களுடன் நேரடியாக தொடர்பு கொண்டுள்ளீர்களா?',
    chinese: '在过去21天中，您是否与COVID-19确诊/疑似/症状/隔离病例直接接触？',
    response: false,
    result: "",
  },
  {
    covid_question_id: 3,
    english: 'Within the last 21 days, have you or your close contacts been to any of the locations or areas where COVID-19 cases have been reported?',
    sinhala: 'පසුගිය දින 21 තුළ, ඔබ හෝ ඔබේ සමීප සම්බන්ධතා COVID-19 සිද්ධීන් වාර්තා වී ඇති ඕනෑම ස්ථානයකට හෝ ප්‍රදේශයකට ගොස් තිබේද?',
    tamil: 'கடந்த 21 நாட்களுக்குள், நீங்கள் அல்லது உங்கள் நெருங்கிய தொடர்புகள் COVID-19 தொற்றுக்கள் பதிவாகியுள்ள இடங்கள் அல்லது பகுதிகளுக்கு சென்றிருந்தீர்களா?',
    chinese: '在过去的21天内，您或您的密友是否曾到过报告COVID-19病例的任何地点或地区？',
    response: false,
    result: "",
  },
  {
    covid_question_id: 4,
    english: 'Have you, or any person who has been in close contact* with you, been exposed to someone who is later found to be COVID-19 Positive, or have requested to be under government quarantine over the last 21 days?',
    sinhala: 'ඔබ හෝ ඔබ සමඟ සමීප සම්බන්ධතා පැවැත්වූ * පුද්ගලයෙක් පසුකාලීනව COVID-19 වැලදී ඇති බව සොයාගත් කෙනෙකුට නිරාවරණය වී තිබේද? නැතහොත් පසුගිය දින 21 තුළ ස්වයන් නිරෝධායනය යටතේ සිටින ලෙස ඉල්ලා තිබේද?',
    tamil: 'நீங்கள், அல்லது உங்களுடன் நெருங்கிய தொடர்பில் இருந்த எந்தவொரு நபரும், பின்னர் COVID-19 நேர்மறை என்று கண்டறியப்பட்ட ஒருவருடன் தொடர்பில் இருந்துள்ளாரா, அல்லது கடந்த 21 நாட்களில் அரசாங்க தனிமைப்படுத்தலின் கீழ் இருக்குமாறு கோறப்பட்டுள்ளீர்களா?',
    chinese: '您或与您保持密切联系*的任何人是否曾与后来被发现为COVID-19阳性的人接触过，或在过去21天内被要求接受政府隔离？',
    response: false,
    result: "",
  },
  {
    covid_question_id: 5,
    english: 'Have there been two or more members in your workplace / office / family having fever and/or symptoms of respiratory infection during the past 21 days?',
    sinhala: 'පසුගිය දින 21 තුළ ඔබේ සේවා ස්ථානයේ / කාර්යාලයේ / පවුලේ සාමාජිකයින් දෙදෙනෙකු හෝ වැඩි ගණනක්, උණ හෝ උණ සහ ශ්වසන ආසාදන වැලදී තිබේද?',
    tamil: 'கடந்த 21 நாட்களில் உங்கள் பணியிடத்தில் / அலுவலகத்தில் / குடும்பத்தில் காய்ச்சல் மற்றும் / அல்லது சுவாச நோய்த்தொற்றின் அறிகுறிகள் உள்ள இரண்டு அல்லது அதற்கு மேற்பட்ட உறுப்பினர்கள் இருந்தார்களா?',
    chinese: '在过去的21天内，您的工作场所/办公室/家庭中是否有两个或多个成员发烧和/或出现呼吸道感染症状？',
    response: false,
    result: "",
  },
  {
    covid_question_id: 6,
    english: 'Have you had any of the following symptoms during the past 21 days? Fever, Headache, Stuffy or Running nose, Cough, Difficult breathing, Sore Throat, Chest pain, Diarrhea, Nausea and vomiting, Muscle pain or joint pain',
    sinhala: 'පසුගිය දින 21 තුළ ඔබට පහත සඳහන් රෝග ලක්ෂණ කිසිවක් වැලදී තිබේද? උණ, හිසරදය, කැස්ස, අපහසු හුස්ම ගැනීම, උගුරේ අමාරුව, පපුවේ වේදනාව, පාචනය, ඔක්කාරය හා වමනය, මාංශ පේශි වේදනාව හෝ සන්ධි වේදනාව',
    tamil: 'கடந்த 21 நாட்களில் பின்வரும் அறிகுறிகள் ஏதேனும் உள்ளதா? காய்ச்சல், தலைவலி, மூச்சுத்திணறல் அல்லது மூக்கு ஒழுகுதல், இருமல், கடினமான சுவாசம், தொண்டை புண், மார்பு வலி, வயிற்றுப்போக்கு, குமட்டல் மற்றும் வாந்தி, தசை வலி அல்லது மூட்டு வலி',
    chinese: '在过去的21天内，您有以下症状吗？ 发烧，头痛，鼻塞或流鼻涕，咳嗽，呼吸困难，喉咙痛，胸痛，腹泻，恶心和呕吐，肌肉痛或关节痛',
    response: false,
    result: "",
  },
  {
    covid_question_id: 7,
    english: 'Have you gone through a PCR test (test for COVID-19) during the past 21 days?',
    sinhala: 'පසුගිය දින 21 තුළ ඔබ PCR පරීක්ෂණයක් (COVID-19 පරීක්ෂණය) සදහා යොමු කලාද?',
    tamil: 'கடந்த 21 நாட்களில் பி.சி.ஆர் சோதனைக்கு (COVID-19 க்கான சோதனை) உட்படுத்தப்பட்டீர்களா?',
    chinese: '在过去的21天中，您是否经过了PCR测试（测试COVID-19）？',
    response: false,
    result: "",
  },
  {
    covid_question_id: 8,
    english: 'Is the PCR test result positive?',
    sinhala: 'PCR පරීක්ෂණය ධනාත්මකද?',
    tamil: 'பி.சி.ஆர் சோதனை முடிவு நேர்மறையானதா?',
    chinese: 'PCR检测结果是否为阳性？',
    response: false,
    result: "",
  }
];

// dynamic covid form
export const GUEST_FILTER_CORPORATE_COVID = [
  {
    corporateId: 20,
    selectedQuestions: [1,2,3,4,5,6,7,8]
  },
  {
    corporateId: 1,
    selectedQuestions: [1,2,3,4,5,6,7,8]
  }
];
